import React from 'react';
import { Row, Col } from 'reactstrap';
import arrow1 from '../assets/arrow1.png';
import arrow2 from '../assets/arrow2.png';

const CalendarTitle = ({ prev, title, next }) => (
  <Row>
    <Col xs='12' className='d-flex justify-content-between mb-4'>
      <img src={arrow1} alt='arrow' className='arrows' onClick={prev} />
      <b className='text-uppercase'>{title}</b>
      <img src={arrow2} alt='arrow' className='arrows' onClick={next} />
    </Col>
  </Row>
);

export default CalendarTitle;
